import { IconButton, Stack, Tooltip } from '@chronosphereio/chrono-ui';
import { CodeTags, FormatBold, FormatItalic, Link } from 'mdi-material-ui';
import React from 'react';
import { useVisualEditor } from './use-markdown-visual-editor';

export enum MarkdownVisualEditorOptions {
  BOLD,
  ITALIC,
  CODE,
  LINK,
}

const DEFAULT_OPTIONS = new Set<MarkdownVisualEditorOptions>([
  MarkdownVisualEditorOptions.BOLD,
  MarkdownVisualEditorOptions.ITALIC,
  MarkdownVisualEditorOptions.CODE,
  MarkdownVisualEditorOptions.LINK,
]);

interface MarkdownVisualEditorProps {
  textAreaRef: React.MutableRefObject<HTMLTextAreaElement | undefined>;
  text: string;
  setText: (val: string) => void;
  otherActions?: React.ReactNode;
  enabledOptions?: Set<MarkdownVisualEditorOptions>;
}

export const MarkdownVisualEditor = ({
  textAreaRef,
  text,
  setText,
  otherActions,
  enabledOptions = DEFAULT_OPTIONS,
}: MarkdownVisualEditorProps) => {
  const { makeSelectionBold, makeSelectionCode, makeSelectionItalic, makeSelectionLink } = useVisualEditor({
    textAreaRef: textAreaRef.current,
    text,
    setText,
  });

  return (
    <Stack direction="row" aria-label="visual editor" spacing={1}>
      {enabledOptions.has(MarkdownVisualEditorOptions.BOLD) && (
        <Tooltip Content="Bold">
          <IconButton onClick={makeSelectionBold}>
            <FormatBold />
          </IconButton>
        </Tooltip>
      )}
      {enabledOptions.has(MarkdownVisualEditorOptions.ITALIC) && (
        <Tooltip Content="Italic">
          <IconButton onClick={makeSelectionItalic}>
            <FormatItalic />
          </IconButton>
        </Tooltip>
      )}
      {enabledOptions.has(MarkdownVisualEditorOptions.CODE) && (
        <Tooltip Content="Code">
          <IconButton onClick={makeSelectionCode}>
            <CodeTags />
          </IconButton>
        </Tooltip>
      )}
      {enabledOptions.has(MarkdownVisualEditorOptions.LINK) && (
        <Tooltip Content="Link">
          <IconButton onClick={makeSelectionLink}>
            <Link />
          </IconButton>
        </Tooltip>
      )}
      {otherActions}
    </Stack>
  );
};
